import { ResizeObserver } from '@juggle/resize-observer';
import { mobilePx } from './constants';
import useAppStore from '@/stores/app';
/**
 * Observes the resize of a given DOM element and executes a callback with the resize information.
 * @param element - The DOM element to observe.
 * @param callback - The callback function to execute with the resize information.
 */

export function observeResize(element: Element, callback: (respone: { isMobile: boolean, contentRect: DOMRectReadOnly }) => void): void {
    const resizeObserver = new ResizeObserver((entries) => {
        const entry = entries[0].contentRect;
        const isMobile = entry.width <= mobilePx;
        const appStore = useAppStore();
        appStore.setIsMobile(isMobile);
        const respone = {
            isMobile: entry.width <= mobilePx,
            contentRect: entry,
        };
        callback(respone);
    });

    resizeObserver.observe(element);
}

/**
 * Plugin to integrate resize observer with Vuex store.
 * @param app - The Nuxt app instance.
 * @param store - The Vuex store instance.
 */
export default () => {
    if (typeof window !== 'undefined') {
        observeResize(document.body, (respone) => {
            console.log(respone)
        });
    }
}
